import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';
import FallbackImage from '../../../../generic/FallbackImage';
import List from '../../../../generic/List';
import ReleasesListRow from './ReleasesListRow';
import type { ProjectGroupRelease } from '../../../../../../shared/model-typings';

type Props = {
  count: number;
  total: number | null; // Null here indicates that the total hasn't been fetched yet.
  isLoading: boolean;
  releases: ProjectGroupRelease[];
};

/**
 * ReleaseGroupReleasesListBody is a flow component for determining
 * what to render in the body of the List, depending on the
 * state of the request.
 */
const ReleaseGroupReleasesListBody: VoidFunctionComponent<Props> = ({
  count,
  total,
  isLoading,
  releases,
}) => {
  if (isLoading) {
    return _.times(count, () => <List.RowLoading />);
  }

  if (total === 0 || (!isLoading && releases.length === 0)) {
    return (
      <FallbackImage
        src="no-results"
        alt="No releases found."
        hasPadding
      >
        No releases found.
      </FallbackImage>
    );
  }

  return releases.map(release => (
    <ReleasesListRow
      key={release.id}
      id={release.id}
      releaseGroupId={release.projectGroupId}
      title={release.title}
      createdAt={release.createdAt}
      isOnlyRelease={total === 1}
    />
  ));
};

export default ReleaseGroupReleasesListBody;
